import { Component, OnInit, EventEmitter, Output } from '@angular/core'
import { Router } from '@angular/router'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import 'rxjs/add/operator/map'
@Component({
  selector: 'app-trading-header',
  templateUrl: './trading-header.component.html',
  styleUrls: ['./trading-header.component.scss']
})
export class TradingHeaderComponent implements OnInit {
  @Output() period = new EventEmitter()
  form: FormGroup
  tradingDate
  radios = [
    { value: '1M', des: '1M' },
    { value: '3M', des: '3M' },
    { value: '6M', des: '6M' },
    { value: '1Y', des: '1Y' },
    { value: '3Y', des: '3Y' },
    { value: 'YTD', des: 'YTD' }
  ]
  viewValue = 'YTD'
  constructor(
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private router: Router
  ) { }

  ngOnInit() {
    const { symbol, period } = this.activatedRoute.snapshot.params

    if (period !== undefined) {
      this.viewValue = period
    }

    this.form = new FormGroup({
      radioValue: new FormControl(this.viewValue)
    })

    this.getLastTradingDate()
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  onChangeData(data) {
    this.viewValue = data
    this.period.emit(this.viewValue)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-header/trading-header.component.ts